"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPageBrandedServiceTypes = void 0;
exports.SetPageBrandedServiceTypes = [
    "Cameo",
    "Song Collab / Feature",
    "Audio Engineering",
    "Music Review",
    "YouTube Reaction",
    "Consultation",
    "Graphic Design",
    "Videography",
    "MediaKits",
    "Featured X",
    "Elite Reviews",
];
//# sourceMappingURL=BrandedButtons.js.map